import { useEffect } from "react";

import { useModuleTitle } from "./modulePersistence.ts";

interface ModuleBreadcrumbProps {
  id: string;
  isLast?: boolean;
}

export const ModuleBreadcrumb = ({ id, isLast }: ModuleBreadcrumbProps) => {
  const title = useModuleTitle(id);
  // total hack: manually update document title when module title changes
  // see useBreadcrumbs() in nautilus-core-designer/src/navigation/useBreadcrumbs.ts
  useEffect(() => {
    if (isLast) {
      document.title = `${title} - Interact`;
    }
  }, [isLast, title]);
  return title;
};
